import React from 'react';
import classname from './Spinner.module.css';

const spinner = () => <div className={classname.Loader} />;
export default spinner;
